import type { QueryClient } from "@tanstack/react-query";

import { REDO_PARTNERS_PORTAL_SERVER_URL } from "../config";

/**
 * Records the logout on the server, best effort, then clears the cached
 * data. The caller clears the token, which signs out other tabs too.
 */
export async function recordLogout(
  token: string | undefined,
  queryClient: QueryClient,
): Promise<void> {
  if (token) {
    try {
      await fetch(`${REDO_PARTNERS_PORTAL_SERVER_URL}/auth/logout`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch {
      // Signing out of this browser mustn't depend on the server.
    }
  }
  queryClient.clear();
}
